import { render, staticRenderFns } from "./ExcelInscripciones.vue?vue&type=template&id=1b0045c4"
import script from "./ExcelInscripciones.vue?vue&type=script&lang=js"
export * from "./ExcelInscripciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports